import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { RequestCacheWithMap } from './request-cache.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
    private cache = inject(RequestCacheWithMap);
    private platformId = inject(PLATFORM_ID);


    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // Disable cache on server to avoid cross-request memory growth in SSR
        if (isPlatformServer(this.platformId)) {
            return next.handle(req);
        }
        // continue if not cachable.
        if (!this.isCachable(req)) {
            return next.handle(req);
        }

        const cachedResponse = this.cache.get(req);

        return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next, this.cache);
    }

    isCachable(req: HttpRequest<any>): any {
        let noCache = req.headers.has('noCache');
        if (noCache) {
            return false;
        }

        return req.method == 'GET';
    }

    /**
     * Get server response observable by sending request to `next()`.
     * Will add the response to the cache on the way out.
     */
    sendRequest(req: HttpRequest<any>, next: HttpHandler, cache: RequestCacheWithMap): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event) => {
                // There may be other events besides the response.
                if (event instanceof HttpResponse) {
                    cache.put(req, event); // Update the cache.
                }
            }),
        );
    }
}
